module.exports = __webpack_public_path__ + "img/e00b89c.png";